import axios from "axios";

const API = (process.env.REACT_APP_API_URL || "https://cctvapi.shopkwality.in/api").replace(/\/$/, "");
export const API_BASE = API.replace(/\/api$/, "");

const client = axios.create({
  baseURL: API,
  timeout: 20000,
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("admin");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default client;
